export const companyListHeaders = [{
  text: 'Firma',
  value: 'name',
},
{
  text: 'Straße',
  value: 'stree',
},
{
  text: 'PLZ',
  value: 'zipCode',
},
{
  text: 'Ort',
  value: 'city',
},
{
  text: 'Aktiv',
  value: 'isActive',
},
  /* {
    text: 'Gelöscht',
    value: 'isDelete'
  },
  {
    text: 'Aktionen',
    value: '',
    sortable: false
  } */
];
